import React from 'react'
import { useNavigate } from 'react-router-dom';

interface CardShowYouProps {
    src: string,
    title: string,
    text: string,
    textButton: string,
    link: string,
}

export const CardShowYou: React.FC<CardShowYouProps> = ({ src, title, text, textButton, link }) => {
    const navigate = useNavigate();
    const handleLink = () => {
        if (link.startsWith('/')) {
            if (link.includes('#')) {
                window.location.href = link;
            } else {
                navigate(link);
            }
        } else {
            window.open(link, '_blank');
        }
    }
    
    return (
        <div className='flex flex-col items-center mb-8'>
            <div
                className="w-96 h-96 rounded-3xl bg-cover bg-center flex flex-col justify-center items-center text-white p-6 relative"
                style={{ backgroundImage: `url(${src})` }}
            >
                <div className="absolute rounded-3xl inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/60"></div>
                <div className='z-10 h-full w-full flex-col flex justify-between '>
                    <h3 className="primaryFont text-center text-2xl font-bold z-10">{title}</h3>
                    <p className="secondaryFont text-center text-xl z-10 mb-3">{text}</p>
                </div>
            </div>
            <button onClick={handleLink} className='z-50 -translate-y-7 bg-[#4CF2C3] px-8 py-2.5 primaryFont underline font-semibold text-lg rounded-full'>{textButton}</button>
        </div>
    )
}
